import React from 'react';

export default function CartInStore(
  props?: React.ComponentPropsWithoutRef<'svg'>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="24"
      height="24"
      viewBox="0 0 900 600"
      {...props}>
      <path fill="none" d="M-444.3,502.8" />
      <path
        fill="#808c98"
        d="M868.3,500.7l-124.7-7c-40.2-2.2-77.3-19.9-104.2-49.8l-102.6-114.3c-8.6-10.2-11.8-23.5-10.6-36.9,1.4-13.1,7.8-25.3,18.5-33.7,19.5-15.5,47.8-14.5,65.5,2l86.7,90.6c6.4,6.4,17.3,6.6,24.1.4,6.8-6.2,7-17.3.4-24.1l-87.3-91c-30.1-28.3-77.5-30.5-110.2-4.2h-.4c-17.3,14.1-28.5,33.9-30.7,56.4-2.8,22.1,3.6,44,18.3,62.4l103.6,114.9c33.1,36.3,78.1,58,127.1,60.8l124.7,7c9.4.6,17.3-6.4,17.9-15.9.6-9.4-6.4-17.3-15.9-17.9v.2ZM894.4,218.6l-83.5-73.1c-42.2-36.7-96.2-58.6-152-62l-36.9-2c-9-.4-17.3,6.4-17.9,15.9h0c-.6,9.6,6.8,17.7,15.9,18.1l36.9,2c48.6,2.8,95.2,21.9,131.7,53.6l83.9,72.9c6.6,6.2,17.7,5.2,23.7-1.4,2.6-3.2,3.6-6.6,3.8-10.2.2-3.6-1.4-10-5.6-13.9v.2Z"
      />
      <path
        fill="#808c98"
        d="M536.3,55.8H48.8C21.9,55.8,0,77.6,0,104.6v48.8h584.9v-48.8c0-26.9-21.9-48.8-48.8-48.8h.2ZM402.4,283.3H.2v178.7c0,26.9,21.9,48.8,48.8,48.8h487.5c19.5,0,36.3-11.4,44.2-28.1,7.8-16.7,1-8.8-2-12.2l-164.7-182.1c-3-3.2-7-5-11.4-5h-.2ZM162.6,433.7c0,6.6-5.4,12.2-12.2,12.2h-73.1c-6.6,0-12.2-5.4-12.2-12.2v-40.6c0-6.6,5.4-12.2,12.2-12.2h73.1c6.6,0,12.2,5.4,12.2,12.2v40.6ZM357.6,433.7c0,6.6-5.4,12.2-12.2,12.2h-138.2c-6.6,0-12.2-5.4-12.2-12.2v-40.6c0-6.6,5.4-12.2,12.2-12.2h138.2c6.6,0,12.2,5.4,12.2,12.2v40.6h0Z"
      />
    </svg>
  );
}
